module.exports = "<p>\n  account works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/account/account.component.html
// module id = ./src/app/component/account/account.component.html
// module chunks = main